import Cocoen from 'cocoen';

window.onload = function () {
  const resizable = document.querySelector('.cocoen');

  if (resizable) {
    new Cocoen(resizable);
  }
};




// WEBPACK FOOTER //
// ./app/blocks/slider-resizable/slider-resizable.js